import { UserDataManager } from "./map/user-data-manager";
import { MapManager } from "./map/map-manager";
import { PrivateDataManager } from "./map/private-data-manager";
import { InteractionManager } from "./map/interaction-manager";
import { DrawControlsStateManager } from "./map/map-libre/controls/draw-controls-manager";

export const userDataManager = new UserDataManager();
export const privateDataManager = new PrivateDataManager();
export const interactionManager = new InteractionManager();
export const drawControlsStateManager = new DrawControlsStateManager();
export const mapManager = new MapManager();
